import { collectContentModuleInstances } from "@bestowinc/tinkertoy-core";
import type {
  ModuleID,
  SlotParentRef,
  VersionString,
  ViewModuleRef,
} from "@bestowinc/tinkertoy-core";

import { getModuleVersion } from "./resolve-module-refs";

/**
 * Lists every `(moduleId, version)` that will be rendered for this view, in
 * tree order (layout, then each content ref before its slots), so callers can
 * `Promise`-prime loads before the first `ModuleRenderer` read (avoids a
 * waterfall of Suspense).
 */
export function collectAllModuleLoadKeys<
  TRef extends SlotParentRef & Pick<ViewModuleRef, "minVersion">,
>(
  layoutRef: Pick<ViewModuleRef, "moduleId" | "minVersion">,
  contentRefs: ReadonlyArray<TRef>,
  resolvedModuleVersions: Record<ModuleID, VersionString>,
): Array<{ moduleId: ModuleID; version: VersionString }> {
  return [
    layoutRef,
    ...collectContentModuleInstances(contentRefs).map(({ ref }) => ref),
  ].map(ref => ({
    moduleId: ref.moduleId,
    version: getModuleVersion(ref, resolvedModuleVersions),
  }));
}
